import { useState, useEffect } from "react";
import "./style.css";
import logo from "../../assets/images/logo.png";
import welcomeGiF from "../../assets/images/GiF/welcome.gif";
import useLoginService from "../../hooks/useLoginService";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Login({ handleClick }) {
  const { auth } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    // if (auth?.token) {
    //   // handleClick("/");
    //   navigate("/", { replace: true });
    // }
  }, [auth, handleClick]);
  const [formData, setFormData] = useState({ username: "", password: "" });
  const { performLogin, loading, error } = useLoginService();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await performLogin(formData.username, formData.password);
    } catch (err) {
      console.log("Login error:", err);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <form onSubmit={handleSubmit} className="login-form-inner">
          <div className="logo">
            <img src={logo} alt="Logo" />
          </div>
          <h1>Login</h1>

          <div className="login-form-group">
            <label htmlFor="username">
              Username <span className="required-star">*</span>
            </label>
            <input
              type="text"
              id="username"
              placeholder="Enter username"
              value={formData.username}
              onChange={handleChange}
            />
          </div>

          <div className="login-form-group">
            <label htmlFor="password">
              Password <span className="required-star">*</span>
            </label>
            <input
              type="password"
              id="password"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
            />
          </div>

          {error && <p className="error-message">{error}</p>}

          <button
            type="submit"
            className="rounded-button login-cta"
            disabled={loading}
          >
            {loading ? "Checking..." : "Login"}
          </button>
        </form>
      </div>

      <div className="onboarding">
        <div className="swiper-container">
          <div className="swiper-wrapper">
            <div className="swiper-slide color-1">
              <div className="slide-image">
                <img src={welcomeGiF} loading="lazy" alt="Welcome GiF" />
              </div>
              <div className="slide-content">
                <h2>Fefdy BrainGym</h2>
                <p>
                  Welcome back, little learner! Let’s explore, create, and have
                  fun while learning new things together.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
